import classnames from 'classnames/bind';
import style from './index.module.scss';
import { useMemo, useState } from "react";
import Common from '../../../Common/Common';
import { Address } from '../../../Net/NetProtocol';
import AddressItem from './AddressItem';
const className = classnames.bind(style);
const star_icon = '/images/common/star_icon.png';

const ShowAddress = ()=>{
    const [showWinState, setWinState] = useState(false);
    const onAddNew = ()=>{
      Common.Common.ShowAccount = false;
      Common.UserData = {SelectAd:0};
    }

    const useraddress = useMemo(()=>{
      let naddress:any = Common.UserData?.address;
      console.log("=======>>>>naddress: ", naddress);
      if(!naddress){
        naddress = [];
      }
      return naddress;
    },[Common.UserData?.address])
    return(
        <div className={className('safety_center_wrap')}>
        <div className={className("safety_center_item_wrap")}>
          <div className={className('safety_center_item_title')} onClick={() => setWinState(!showWinState)}>
            <div className={className('left_safety_icon')}>
              <img src={star_icon} alt="star_icon" />
            </div>
            <div className={className('title_text')}>{"Shipping address"}</div>
            <div className={className('title_right_arrow', {title_right_arrow_up: showWinState})}></div>
          </div>
          <div className={className('safety_center_content_box')} style={{height: showWinState ? 'auto' : '0'}}>
            {
              useraddress && useraddress.map((value:Address, index:number)=>{
                return(
                  <AddressItem key={index} userad={value} index={index} />
                )
              })
            }
            {
              !useraddress||useraddress.length<3&&
              <button className={className('submit_btn')} onClick={onAddNew}>Add New Address</button>
            }
          </div>
        </div>
        </div>
    )
}

export default ShowAddress;